import { render, staticRenderFns } from "./AreaReport.vue?vue&type=template&id=07678f20&scoped=true"
import script from "./AreaReport.vue?vue&type=script&lang=ts"
export * from "./AreaReport.vue?vue&type=script&lang=ts"
import style0 from "./AreaReport.vue?vue&type=style&index=0&id=07678f20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07678f20",
  null
  
)

export default component.exports